import {
  Component,
  ViewEncapsulation,
  OnInit,
  HostListener
} from '@angular/core';

import { Router, ActivatedRoute} from '@angular/router';

import { RequestsServices } from '../../../../services/requests.service';
import { UserService } from '../../../../services/user.service';
import { StorageService } from '../../../../services/storage.service';
import { PageBase } from '../../../../page.base';
import { ToasterService } from '../../../../services/toaster.service';
import { CostCenterService } from 'src/app/services/cost-center.service';

@Component({
  selector: 'app-colabs-registration',
  templateUrl: './colabs-registration.component.html',
  providers: [ RequestsServices, StorageService, UserService, CostCenterService ],
  encapsulation: ViewEncapsulation.None
})
export class ColabsRegistrationComponent extends PageBase implements OnInit {
  public isLoading = false;
  public isEdit = false;
  private establishmentId: string;
  private companyId: string;
  public typeBusiness: string;
  public companyGroups: Array<any>;

  // TODO: Refactoring to use interfaces
  public employeeData: any = {
    companyId: this.companyId,
    id: null,
    firstName: '',
    surname: '',
    email: '',
    cpf: '',
    costCenterId: '',
    profilesId: null,
    emailPersonal: '',
    gender: '',
    hasChilds: '',
    phone: '',
    birthDate: '',
    cep: '',
    jobPosition: '',
    companyUnit: '',
    employeeRegistrationNumber: '',
    status: 'invited',
    emailVerified: false,
    inviteSentDate: null,
    typeBusiness: null
  };

  public inputErrors;
  private employeeObject;

  @HostListener('window:scroll', ['$event']) onScrollEvent($event) {
    const botElmt = document.getElementsByClassName('colab-robot');
    const optionalInfoElementWrapper = document.getElementsByClassName('optional-info-wrp');
    const optionalInfoElementWrapperPostionTop = optionalInfoElementWrapper[0].getBoundingClientRect().top;
    const distanceToTop = 170;

    if (optionalInfoElementWrapperPostionTop <= distanceToTop) {
      if (!botElmt[0].classList.contains('personal-info-position')) {
        botElmt[0].classList.add('personal-info-position');

        botElmt[0].classList.add('colabot-hide');
        botElmt[0].classList.remove('animate-fade-in');
        setTimeout(() => {
          botElmt[0].classList.remove('colabot-hide');
          botElmt[0].classList.add('animate-fade-in');
        }, 100);
      }
    } else {
      if (botElmt[0].classList.contains('personal-info-position')) {
        botElmt[0].classList.remove('personal-info-position');

        botElmt[0].classList.add('colabot-hide');
        botElmt[0].classList.remove('animate-fade-in');
        setTimeout(() => {
          botElmt[0].classList.remove('colabot-hide');
          botElmt[0].classList.add('animate-fade-in');
        }, 100);
      }

    }
  }

  constructor(private toasterService: ToasterService,
              private request: RequestsServices,
              private route: ActivatedRoute,
              private router: Router,
              private costCenter: CostCenterService,
              private storage: StorageService,
              private userService: UserService) {
    super();

    const loggedAccount = this.userService.getLoggedAccount();
    this.typeBusiness = this.userService.getTypeAccount();

    if (this.typeBusiness === 'company') {
      this.companyId = loggedAccount['id'];
    } else if (this.typeBusiness === 'establishment') {
      this.establishmentId = loggedAccount['id'];
    } else {
      alert('Falha ao recuperar dados.');
    }

  }

  public ngOnInit(): void {
    this.scrollToTop();

    if (this.route.snapshot.params.employeeId) {
      this.isLoading = true;
      const employeeId = this.route.snapshot.params.employeeId;
      this.request.get({path: 'accounts', pathParam: `/${employeeId}`}).then((employees) => {
        this.isLoading = false;
        this.isEdit = true;
        employees = this.formatBirthDate(employees);
        this.transformEmployeeObjectFromAPI(employees);
      }, (err) => {
        this.isLoading = false;
      });
    }

    this.loadUnitAddresses();
  }

  private formatBirthDate(employee): any {
    // Remove the time from birthDate
    if (employee && employee.birthDate) {
      const birthDate = employee.birthDate;
      const birthDateArray = birthDate.split('T');
      employee.birthDate = birthDateArray[0];
    }

    return employee;
  }

  private getTypeBusiness(): string {
    return this.typeBusiness;
  }

  public loadUnitAddresses(): void {
    console.log('colabs-registration', 'load-cost-centers');
    let typeResource;
    let resourceId;

    if (this.getTypeBusiness() === 'company') {
      typeResource = 'companies';
      resourceId = this.companyId;
    } else {
      typeResource = 'establishments';
      resourceId = this.establishmentId;
    }

    this.isLoading = true;
    const params = [
      { param: 'companyId', value: resourceId, },
      { param: 'limit', value: 0 },
      { param: 'skip', value: 0 }
    ];

    this.costCenter.getCostCenters(params).then(res => {
      this.isLoading = false;
      this.companyGroups = res.data;
    });
  }

  public saveEmployee(): void {
    if (this.validateModelFields()) {
      this.createEmployeeObject();
      this.employeeObject.status = 'not_invited';

      const data = {
        data: [this.employeeObject],
        companyId: this.companyId,
        establishmentId: this.establishmentId,
        typeBusiness: this.typeBusiness,
      };

      this.sendEmployee(data, 'createEmployee');
    }
  }

  public updateEmployee(): void {
    if (this.validateModelFields()) {
      this.updateEmployeeObject();

      const data = {
        data: [this.employeeObject],
        companyId: this.companyId,
        establishmentId: this.establishmentId,
        typeBusiness: this.typeBusiness,
      };

      this.sendEmployee(data, 'updateEmployee');
    }
  }

  public saveAndSendInvitation(): void {
    if (this.employeeData.email) {
      if (this.validateModelFields()) {
        this.createEmployeeObject();
        this.employeeObject.inviteSentDate = new Date();

        const data = {
          data: [this.employeeObject],
          companyId: this.companyId,
          establishmentId: this.establishmentId,
          typeBusiness: this.typeBusiness,
          sendInvitation: true
        };

        this.sendEmployee(data, 'createEmployee');
      }
    } else {
      this.toasterService.info('Oops!',
      'Para convidar, é necessário cadastrar o email do colaborador.', true, 4000);
    }
  }

  public sendInvitation(): void {
    if (this.employeeData.email) {
      if (this.validateModelFields()) {
        this.updateEmployeeObject();
        this.employeeObject.inviteSentDate = new Date();

        const data = {
          data: [this.employeeObject],
          companyId: this.companyId,
          sendInvitation: true,
          typeBusiness: this.employeeObject.typeBusiness
        };

        this.sendEmployee(data, 'updateEmployee');
      }
    } else {
      this.toasterService.info('Oops!',
      'Para convidar, é necessário cadastrar o email do colaborador.', true, 4000);
    }
  }

  public sendEmployee(data, endpoint): void {
    this.isLoading = true;
    this.request.post('customers', data, endpoint).then(() => {
      this.isLoading = false;
      this.toasterService.info('Sucesso!',
        `${data.sendInvitation ? 'Convite enviado' : 'Cadastro realizado'} com sucesso.`, true, 4000);
      this.router.navigate(['/company/manage']);
    }, (err) => {
      this.isLoading = false;

      if (data.sendInvitation) {
        if (err.status === 422) {
          this.displayValidationErrors(err);
        } else {
          this.toasterService.info('Oops!', 'Ocorreu um erro ao tentar enviar o convite para o seu funcionário. ' +
            'Por favor entre em contato com nosso suporte e informe desse problema.',
            true, 4000);
        }
      } else {
        this.displayValidationErrors(err);
        const errorAsObj = JSON.parse(err['_body']);

        if (errorAsObj.success === false &&
           errorAsObj.error &&
          errorAsObj.error.message === 'Error! CPF and Email are being used by different customers.') {
          this.toasterService.info('Atenção!',
            'CPF e Email já estão sendo usados por dois usuários distintos. Entre em contato com nosso suporte em suporte@allya.com.br',
             false, 4000);
        } else {
          this.toasterService.info('Atenção!', 'Alguns campos possuem erros.', false, 4000);
        }
      }
    });
  }

  private displayValidationErrors(response: any): void {
    if (response.status === 422) {
      this.scrollToTop();

      // Validations errors
      const errorsObject = response.error;
      const errors = errorsObject.data.errors;
      let validationErrors;

      if (errors.length > 0) {
        validationErrors = errors[0].errors.messages;
      }

      this.inputErrors = validationErrors;
    }
  }

  private scrollToTop(): void {
    window.scrollTo(0, 0);
  }

  private createEmployeeObject(): void {
    const data = {
      first_name: this.employeeData.firstName.trim(),
      surname: this.employeeData.surname.trim(),
      email: this.employeeData.email,
      cpf: this.removeMasks(this.employeeData.cpf, ''),
      profilesId: this.employeeData.profilesId,
      costCenterId: this.employeeData.costCenterId,
      emailPersonal: this.employeeData.emailPersonal,
      gender: this.employeeData.gender,
      hasChilds: this.employeeData.hasChilds === '1' ? true : false,
      phone: this.employeeData.phone,
      birthDate: this.employeeData.birthDate === '' ? null : this.employeeData.birthDate,
      cep: this.employeeData.cep,
      jobPosition: this.employeeData.jobPosition,
      companyUnit: this.employeeData.companyUnit,
      employeeRegistrationNumber: this.employeeData.employeeRegistrationNumber,
      status: this.employeeData.status,
      emailVerified: false,
      inviteSentDate: null,
      typeBusiness: this.getTypeBusiness(),
    };

    this.employeeObject = data;
  }

  private updateEmployeeObject(): void {
    const data = {
      id: this.employeeData.id,
      first_name: this.employeeData.firstName.trim(),
      surname: this.employeeData.surname.trim(),
      email: this.employeeData.email,
      cpf: this.removeMasks(this.employeeData.cpf, ''),
      profilesId: this.employeeData.profilesId,
      costCenterId: this.employeeData.costCenterId,
      emailPersonal: this.employeeData.emailPersonal,
      gender: this.employeeData.gender,
      hasChilds: this.employeeData.hasChilds === '1' ? true : false,
      phone: this.employeeData.phone,
      birthDate: this.employeeData.birthDate,
      cep: this.employeeData.cep,
      jobPosition: this.employeeData.jobPosition,
      companyUnit: this.employeeData.companyUnit,
      employeeRegistrationNumber: this.employeeData.employeeRegistrationNumber,
      status: this.employeeData.status,
      emailVerified: this.employeeData.emailVerified,
      inviteSentDate: this.employeeData.inviteSentDate,
      typeBusiness: this.employeeData.typeBusiness,
    };

    this.employeeObject = data;
  }

  private transformEmployeeObjectFromAPI(employeeData: any): void {
    this.employeeData = {
      id: employeeData.id,
      firstName: employeeData.first_name,
      surname: employeeData.surname,
      email: employeeData.email,
      cpf: employeeData.cpf,
      profilesId: employeeData.profilesId,
      emailPersonal: employeeData.emailPersonal,
      gender: employeeData.gender,
      costCenterId: employeeData.costCenterId,
      hasChilds: employeeData.hasChilds === true ? '1' : '0',
      phone: employeeData.phone,
      birthDate: employeeData.birthDate,
      cep: employeeData.cep,
      jobPosition: employeeData.jobPosition,
      companyUnit: employeeData.companyUnit,
      employeeRegistrationNumber: employeeData.employeeRegistrationNumber,
      emailVerified: employeeData.emailVerified,
      status: employeeData.status,
      inviteSentDate: employeeData.inviteSentDate,
      typeBusiness: employeeData.typeBusiness,
    };
  }

  private validateModelFields(): boolean {
    this.inputErrors = {};

    if (!this.employeeData.firstName) {
      this.inputErrors.first_name = ['NAME_CANT_BE_BLANK'];
    }

    if (!this.employeeData.surname) {
      this.inputErrors.surname = ['SURNAME_CANT_BE_BLANK'];
    }

    if (!this.employeeData.cpf && !this.employeeData.email) {
      this.inputErrors.cpf = ['CPF_CANT_BE_BLANK'];
    }

    if (!this.employeeData.profilesId) {
      this.inputErrors.profilesId = ['PROFILE_CANT_BE_BLANK'];
    }

    if (this.typeBusiness === 'company' && this.companyGroups && this.companyGroups.length > 0 && !this.employeeData.costCenterId) {
      this.inputErrors.companyUnit = ['COST_CENTER_CANT_BE_BLANK'];
    }

    if (Object.keys(this.inputErrors).length > 0) {
      this.toasterService.info('Atenção!', 'Todos os campos obrigatórios devem ser preenchidos!', true, 2000);
      return false;
    }

    return true;
  }

  public hasError(inputName): boolean {
    return this.inputErrors && inputName in this.inputErrors && this.inputErrors[inputName].length > 0;
  }

  public getError(inputName): string {
    if (this.inputErrors && inputName in this.inputErrors && this.inputErrors[inputName].length > 0) {
      return this.inputErrors[inputName][0];
    }
    return '';
  }


  public isDisabledCpf(value) :boolean {
    if(value && value.length === 11){
      return true
    }else {
      return false;
    }
  }
}
